import request from '@/utils/request'

// getDictDataByType
export function getDictDataByType(type) {
    return request({
        url: '/system/dict/data/type/' + type,
        headers: {
            isToken: true,
        },
        method: 'get',
    })
}

// 省市树
export function provinceTree(type) {
    return request({
        url: '/system/province/provinceTree',
        headers: {
            isToken: true,
        },
        method: 'get',
    })
}


